import React, { useState } from 'react'
import router from '@Site/Router'
import Button from '@SiteComponents/Button'
import AlertError from '@Images/alert_error.svg'

import './RenewSubscriptionAlert.scss'

interface RenewSubscriptionAlertProps {
  readonly userCanManageSubscription: boolean
  readonly tooltipDelay: number
}

const RenewSubscriptionAlert: React.FC<RenewSubscriptionAlertProps> = props => {
  const {
    tooltipDelay,
    userCanManageSubscription,
  } = props

  const [showInfo, setShowInfo] = useState(false)
  const [infoTimeout, setInfoTimeout] = useState<ReturnType<typeof setTimeout> | null>(null)
  const shouldDisableRenewButton = !userCanManageSubscription
  const shouldShowInfo = showInfo && shouldDisableRenewButton

  const handleRenew = () => {
    router.navigate('/subscriptions')
  }

  const displayInfo = () => {
    if (infoTimeout) { return }

    const newInfoTimeout = setTimeout(() => {
      setShowInfo(true)
    }, tooltipDelay)
    setInfoTimeout(newInfoTimeout)
  }

  const hideInfo = () => {
    if (!infoTimeout) { return }

    setShowInfo(false)
    clearTimeout(infoTimeout)
    setInfoTimeout(null)
  }

  const renderInfo = () => {
    return (
      <div className="RenewSubscriptionAlert__info-disabled">
        Contact your account admin or the Checksub support to upgrade
      </div>
    )
  }

  return (
    <div className="RenewSubscriptionAlert">
      <AlertError />
      <div className="RenewSubscriptionAlert__right">
        <div className="RenewSubscriptionAlert__header">
          Your free trial has ended
        </div>
        <div className="RenewSubscriptionAlert__right-bottom">
          <div className="RenewSubscriptionAlert__text">
            To create new projects, add languages etc., you need an active plan.
          </div>
          <div
            className="RenewSubscriptionAlert__button-wrapper"
            onMouseEnter={displayInfo}
            onMouseLeave={hideInfo}
          >
            <Button
              caption="Choose a plan"
              onClick={handleRenew}
              styleType="gray"
              size="small"
              disabled={shouldDisableRenewButton}
            />
            {shouldShowInfo && renderInfo()}
          </div>
        </div>
      </div>
    </div>
  )
}

export default RenewSubscriptionAlert
